import styled from '@emotion/styled';

export const Wizard = styled.div`
`;
